import { createStore, StoreApi } from 'zustand/vanilla';
import { persist } from 'zustand/middleware';
import type { User } from './types/userTypes';

export type AppState = {
  user?: User;
  setUser: (u: User) => void;
  updateUser: (patch: Partial<User>) => void;
  clearUser: () => void;
};

type PersistedAppStore = StoreApi<AppState> & {
  persist: {
    clearStorage: () => Promise<void>;
  };
};

export const createAppStore = (): StoreApi<AppState> =>
  createStore<AppState, [["zustand/persist", AppState]]>(
    persist(
      (set) => ({
        user: undefined,
        setUser: (u) => set({ user: u }),
        updateUser: (patch) =>
          set((prev) => ({ user: prev.user ? { ...prev.user, ...patch } : undefined })),
        clearUser: () => set({ user: undefined }),
      }),
      { name: 'get-eat-client:storage' }
    )
  );

export const deleteUser = async () => {
  await (store as unknown as PersistedAppStore).persist.clearStorage();
  store.setState((state) => ({ ...state, user: undefined }));
};

export const store = createAppStore();
